import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5daafa6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-wrapper" }
const _hoisted_2 = { class: "h4 title" }
const _hoisted_3 = {
  key: 0,
  class: "message"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_5 = {
  class: "form login-form",
  method: "post"
}
const _hoisted_6 = { class: "checkbox" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_input_form = _resolveComponent("input-form")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_checkbox_element = _resolveComponent("checkbox-element")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('staff.login.view.title')), 1),
    _createElementVNode("div", {
      class: _normalizeClass(["error-message", { '-visible': !!_ctx.error }])
    }, [
      (_ctx.error === '401')
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('staff.login.view.invalidCredentials')), 1),
            _hoisted_4,
            _createVNode(_component_router_link, {
              class: "link copy -font-size-16 -font-weight-700",
              to: { name: 'requestPasswordReset' }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('staff.login.view.forgotPasswordQuestion')), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("form", _hoisted_5, [
      _createVNode(_component_input_form, {
        type: "tel",
        class: "tel",
        label: _ctx.$t('staff.login.view.mobile'),
        name: "username",
        autocomplete: "username",
        required: "",
        modelValue: _ctx.username,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event))
      }, null, 8, ["label", "modelValue"]),
      _createVNode(_component_router_link, {
        class: "link copy -font-size-14 -font-weight-700",
        to: { name: 'requestPasswordReset' }
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('staff.login.view.forgotPassword')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_input_form, {
        class: "password",
        type: "password",
        name: "password",
        autocomplete: "current-password",
        modelValue: _ctx.password,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
        isPW: "",
        label: _ctx.$t('staff.login.view.password'),
        required: ""
      }, null, 8, ["modelValue", "label"]),
      _createVNode(_component_app_button, {
        class: "button -primary",
        disabled: _ctx.password === '' || _ctx.username === '',
        label: _ctx.$t('staff.login.view.login'),
        type: "submit"
      }, null, 8, ["disabled", "label"]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_checkbox_element, {
          modelValue: _ctx.rememberMe,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.rememberMe) = $event)),
          name: "rememberme",
          label: _ctx.$t('staff.login.view.rememberMe'),
          class: "checkbox"
        }, null, 8, ["modelValue", "label"])
      ])
    ])
  ]))
}